export const allCounties = {
  UA: "UA",
  SK: "SK",
  EN: "EN",
};
